import { Modal, notification } from "antd";
import { useTranslation } from "react-i18next";
import useClientsApi from "../hooks/useClientsApi";
import { MdDelete } from "react-icons/md";
import TooltipButton from "views/Documents/components/TooltipButton";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function RemoveButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { deleteClient } = useClientsApi();

  const confirmDelete = (id: ID) => {
    Modal.confirm({
      title: t("Delete client"),
      content: t("Are you sure about delete this client?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    const response = await deleteClient({
      variables: {
        id,
      },
    });

    if (response?.data?.deleteClient?.success) {
      notification.success({
        message: t("Client"),
        description: t("Deleted Successfully"),
        placement: "bottomLeft",
      });
    } else {
      notification.error({
        message: t("Client"),
        description: t("Client have documents associated."),
        placement: "bottomLeft",
      });
    }

    refetch!();
  };

  return (
    <TooltipButton
      variant="delete"
      placement="top"
      handleOnClick={() => confirmDelete(id)}
      icon={<MdDelete />}
    />
  );
}
